// public/js/components/tabs.js

export default function Tabs(rootEl) {
  const tabs = Array.from(rootEl.querySelectorAll('[role="tab"]'));
  const panels = Array.from(rootEl.querySelectorAll('[role="tabpanel"]'));

  if (tabs.length === 0 || panels.length === 0) {
    throw new Error('Tabs: Missing tabs or panels');
  }

  const activateTab = (activeTab) => {
    const targetId = activeTab.getAttribute('aria-controls');

    // Update Tab State
    tabs.forEach((tab) => {
      const isActive = (tab === activeTab);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
      
      // Toggle Visual Classes
      if (isActive) {
        tab.classList.remove('border-transparent', 'text-slate-500', 'hover:text-slate-700', 'hover:border-slate-300');
        tab.classList.add('border-teal-500', 'text-teal-600');
      } else {
        tab.classList.add('border-transparent', 'text-slate-500', 'hover:text-slate-700', 'hover:border-slate-300');
        tab.classList.remove('border-teal-500', 'text-teal-600');
      }
    });

    // Update Panel Visibility
    panels.forEach((panel) => {
      if (panel.id === targetId) {
        panel.classList.remove('hidden');
      } else {
        panel.classList.add('hidden');
      }
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      activateTab(e.currentTarget);
    });

    // Keyboard Support
    tab.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        const next = tab.nextElementSibling || tabs[0];
        next.focus();
        next.click();
      } else if (e.key === 'ArrowLeft') {
        const prev = tab.previousElementSibling || tabs[tabs.length - 1];
        prev.focus();
        prev.click();
      }
    });
  });
}